import { SxProps, Theme } from '@mui/material';
import { CrmColors } from '../../crm-theme';

const SIZES = {
    small: { height: 22, font: '10.5px', dot: 7 },
    medium: { height: 26, font: '12.5px', dot: 8 },
};

export type StatusChipSize = keyof typeof SIZES;

export const statusDotSx = (color: string, size: StatusChipSize): SxProps<Theme> => ({
    width: SIZES[size].dot,
    height: SIZES[size].dot,
    borderRadius: '50%',
    bgcolor: color,
    ml: '6px !important',
});

/// Fundo na cor do status, translúcido; `clickable` ganha cursor e hover porque abre o menu.
export const statusChipSx = (cc: CrmColors, color: string, size: StatusChipSize, clickable: boolean): SxProps<Theme> => ({
    bgcolor: color + '22',
    color: cc.textPrimary,
    fontWeight: 700,
    fontSize: SIZES[size].font,
    height: SIZES[size].height,
    borderRadius: '999px',
    padding: '3px 9px',
    // Status comprido ganha reticências em vez de empurrar o que está ao lado.
    minWidth: 0,
    maxWidth: 160,
    '& .MuiChip-label': { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
    '& .MuiChip-icon': { color, flexShrink: 0 },
    ...(clickable && { cursor: 'pointer', '&:hover': { bgcolor: color + '3a' } }),
});
